// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input:not(.Common) {
  position: relative;
}
.Input:not(.Common)[type=number] {
  -moz-appearance: none;
  appearance: none;
}
.Input:not(.Common)[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.Input:not(.Common)[type=number] + .Input-Controls {
  display: flex;
  flex-direction: column;
}
.Input:not(.Common)[type=number] + .Input-Controls > button {
  flex-grow: 1;
  border: 1px solid rgba(0, 0, 0, 0.25);
  padding: 0;
  line-height: 0;
  width: 2rem;
}
.Input:not(.Common)[type=number] + .Input-Controls > button:first-child {
  border-top-right-radius: var(--bs-border-radius);
}
.Input:not(.Common)[disabled] {
  box-shadow: none !important;
}
.Input:not(.Common)[type=checkbox] {
  appearance: none;
  width: 1.25rem;
  height: 1.25rem;
  border: 1px solid var(--bs-gray-600);
  box-shadow: none !important;
  background-color: #fff;
  border-radius: 0.25rem;
  position: relative;
  outline: none;
  cursor: pointer;
}
.Input:not(.Common)[type=checkbox]:focus {
  outline: none;
}
.Input:not(.Common)[type=checkbox]:checked {
  background-color: var(--bs-secondary);
  border: 1px solid var(--bs-secondary);
}
.Input:not(.Common)[type=checkbox]:checked::after {
  content: "";
  position: absolute;
  top: 0;
  left: 4px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.InputWithIcon {
  flex-wrap: nowrap;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: var(--bs-border-radius);
}
.InputWithIcon .input-group-text {
  background-color: transparent;
  border: none;
  padding-right: 0;
  padding-left: 0;
}
.InputWithIcon .input-group-text .btn {
  border: none;
  padding-right: 0;
  cursor: default;
}
.InputWithIcon .input-group-text + .Input {
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Input/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAAE;EACE,qBAAA;EACA,gBAAA;AAEJ;AADI;EACE,wBAAA;AAGN;AADI;EACE,aAAA;EACA,sBAAA;AAGN;AAFM;EACE,YAAA;EACA,qCAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;AAIR;AAHQ;EACE,gDAAA;AAKV;AAAE;EACE,2BAAA;AAEJ;AAAE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,oCAAA;EACA,2BAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AAEJ;AAAI;EACE,aAAA;AAEN;AACI;EACE,qCAAA;EACA,qCAAA;AACN;AACM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;AACR;;AAKA;EACE,iBAAA;EACA,qCAAA;EACA,sCAAA;AAFF;AAGE;EACE,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AADJ;AAEI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;AAAN;AAEI;EACE,YAAA;AAAN","sourcesContent":[".Input:not(.Common) {\n  position: relative;\n  &[type='number'] {\n    -moz-appearance: none;\n    appearance: none;\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n    }\n    + .Input-Controls {\n      display: flex;\n      flex-direction: column;\n      > button {\n        flex-grow: 1;\n        border: 1px solid rgba(0, 0, 0, 0.25);\n        padding: 0;\n        line-height: 0;\n        width: 2rem;\n        &:first-child {\n          border-top-right-radius: var(--bs-border-radius);\n        }\n      }\n    }\n  }\n  &[disabled] {\n    box-shadow: none !important;\n  }\n  &[type='checkbox'] {\n    appearance: none;\n    width: 1.25rem;\n    height: 1.25rem;\n    border: 1px solid var(--bs-gray-600);\n    box-shadow: none !important;\n    background-color: #fff;\n    border-radius: 0.25rem;\n    position: relative;\n    outline: none;\n    cursor: pointer;\n\n    &:focus {\n      outline: none;\n    }\n\n    &:checked {\n      background-color: var(--bs-secondary);\n      border: 1px solid var(--bs-secondary);\n\n      &::after {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 4px;\n        width: 5px;\n        height: 10px;\n        border: solid #fff;\n        border-width: 0 2px 2px 0;\n        transform: rotate(45deg);\n      }\n    }\n  }\n}\n\n.InputWithIcon {\n  flex-wrap: nowrap;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  border-radius: var(--bs-border-radius);\n  .input-group-text {\n    background-color: transparent;\n    border: none;\n    padding-right: 0;\n    padding-left: 0;\n    .btn {\n      border: none;\n      padding-right: 0;\n      cursor: default;\n    }\n    + .Input {\n      border: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
